import { fromJS } from 'immutable';

import * as exportActions from '../actions/export';
import { SUCCESS, START, ERROR } from '@modules/appraisal/actions/global';
import { fetchingState } from '@constants';
import * as _ from 'lodash';

const initialState = {
  ownerAgentExportLog: {
    data: [],
    state: null,
  },
  appraisalExport: {
    data: [],
    state: null,
  },
  appraisalExportBeta: {
    data: [],
    totalRecords: 0,
    state: null,
  },
  appraisalExportJSON: {
    data: [],
    state: null,
  },
  ptd: {
    data: [],
    state: null,
  },
  bppRenditionsExport: {
    data: [],
    totalRecords: 0,
    state: null,
  },
  allYears: {},
  rollCorrections: {},
  propertyTypes: [],
  exportFormats: [],
  eventFormOptions: { data: [], state: null },
};

export default (state = fromJS(initialState), action) => {
  let newState;
  switch (action.type) {
    case exportActions.FETCH_OWNER_AGENT_EXPORT_LOG[START]:
      return state.setIn(
        ['ownerAgentExportLog', 'state'],
        fetchingState.FETCHING,
      );

    case exportActions.FETCH_OWNER_AGENT_EXPORT_LOG[SUCCESS]:
      newState = state.setIn(
        ['ownerAgentExportLog', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['ownerAgentExportLog', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case exportActions.FETCH_OWNER_AGENT_EXPORT_LOG[ERROR]:
      return state.setIn(['ownerAgentExportLog', 'state'], fetchingState.ERROR);

    case exportActions.FETCH_APPRAISAL_EXPORT[START]:
      return state.setIn(['appraisalExport', 'state'], fetchingState.FETCHING);

    case exportActions.FETCH_APPRAISAL_EXPORT[SUCCESS]:
      newState = state.setIn(
        ['appraisalExport', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['appraisalExport', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case exportActions.FETCH_APPRAISAL_EXPORT[ERROR]:
      return state.setIn(['appraisalExport', 'state'], fetchingState.ERROR);

    case exportActions.FETCH_APPRAISAL_BETA_EXPORT[START]:
      return state.setIn(
        ['appraisalExportBeta', 'state'],
        fetchingState.FETCHING,
      );

    case exportActions.FETCH_APPRAISAL_BETA_EXPORT[SUCCESS]:
      return state
        .setIn(['appraisalExportBeta', 'state'], fetchingState.LOADED)
        .setIn(
          ['appraisalExportBeta', 'data'],
          fromJS(_.get(action, 'data.results.runList', [])),
        )
        .setIn(
          ['appraisalExportBeta', 'totalRecords'],
          _.get(action, 'data.results.totalRuns', 0),
        );
    case exportActions.FETCH_APPRAISAL_BETA_EXPORT[ERROR]:
      return state.setIn(['appraisalExportBeta', 'state'], fetchingState.ERROR);

    case exportActions.FETCH_APPRAISAL_EXPORT_JSON[START]:
      return state.setIn(
        ['appraisalExportJSON', 'state'],
        fetchingState.FETCHING,
      );

    case exportActions.FETCH_APPRAISAL_EXPORT_JSON[SUCCESS]:
      return state
        .setIn(['appraisalExportJSON', 'state'], fetchingState.LOADED)
        .setIn(
          ['appraisalExportJSON', 'data'],
          fromJS(action.data ? action.data.results : []),
        );
    case exportActions.FETCH_APPRAISAL_EXPORT_JSON[ERROR]:
      return state.setIn(['appraisalExportJSON', 'state'], fetchingState.ERROR);

    case exportActions.FETCH_PTD[START]:
      return state.setIn(['ptd', 'state'], fetchingState.FETCHING);

    case exportActions.FETCH_PTD[SUCCESS]:
      newState = state.setIn(['ptd', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['ptd', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case exportActions.FETCH_PTD[ERROR]:
      return state.setIn(['ptd', 'state'], fetchingState.ERROR);

    case exportActions.FETCH_ROLL_CORRECTIONS[START]:
      return state.setIn(['rollCorrections', 'state'], fetchingState.FETCHING);

    case exportActions.FETCH_ROLL_CORRECTIONS[SUCCESS]:
      newState = state.setIn(
        ['rollCorrections', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['rollCorrections', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case exportActions.FETCH_ROLL_CORRECTIONS[ERROR]:
      return state.setIn(['rollCorrections', 'state'], fetchingState.ERROR);

    case exportActions.EXPORT_EARS_RUN[SUCCESS]:
      const newList = state
        .getIn(['ptd', 'data'])
        .toJS()
        .map(p => {
          if (p.ptdRunID === action.ptdRunID) {
            return {
              ...p,
              exportStatus: 'In Progress',
            };
          }
          return p;
        });
      return state.setIn(['ptd', 'data'], fromJS(newList));

    case exportActions.FETCH_PROPERTY_TYPES[SUCCESS]:
      return state.setIn(
        ['propertyTypes'],
        fromJS(action.data ? action.data.results : []),
      );

    case exportActions.FETCH_EXPORT_FORMATS[SUCCESS]:
      return state.setIn(
        ['exportFormats'],
        fromJS(action.data ? action.data.results : []),
      );

    case exportActions.FETCH_BPP_RENDITIONS_EXPORTS[START]:
      return state.setIn(
        ['bppRenditionsExport', 'state'],
        fetchingState.FETCHING,
      );
  
    case exportActions.FETCH_BPP_RENDITIONS_EXPORTS[SUCCESS]:
      return state
        .setIn(['bppRenditionsExport', 'state'], fetchingState.LOADED)
        .setIn(
          ['bppRenditionsExport', 'data'],
          fromJS(action.data ? action.data.results : []),
        )
        .setIn(
          ['bppRenditionsExport', 'totalRecords'],
          _.get(action, 'data.results.length', 0),
        );;
    case exportActions.FETCH_BPP_RENDITIONS_EXPORTS[ERROR]:
      return state.setIn(['bppRenditionsExport', 'state'], fetchingState.ERROR);

    case exportActions.FETCH_PROPERTY_FORM_OPTIONS_EVENTS[START]: {
      return state
        .setIn(['eventFormOptions', 'data'], fromJS([]))
        .setIn(['eventFormOptions', 'state'], fetchingState.FETCHING);
      }
    case exportActions.FETCH_PROPERTY_FORM_OPTIONS_EVENTS[SUCCESS]: {
      return state
        .setIn(['eventFormOptions', 'state'], fetchingState.LOADED)
        .setIn(
          ['eventFormOptions', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case exportActions.FETCH_PROPERTY_FORM_OPTIONS_EVENTS[ERROR]: {
      return state.setIn(['eventFormOptions', 'state'], fetchingState.ERROR);
    }

    default:
      return state;
  }
};
